import { Icon } from "./Icon.tsx";

/** Yellow "i" icon with a native tooltip (title) — replaces the .map-notice paragraphs that were just a hint, not a status notice that needs to be visible without hovering. */
export function InfoIcon({ text }: { text: string }) {
  return (
    <span className="info-icon" title={text} aria-label={text} tabIndex={0}>
      <Icon strokeLinecap="butt" strokeLinejoin="miter">
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="11" x2="12" y2="16" />
        <circle cx="12" cy="8" r="1" fill="currentColor" stroke="none" />
      </Icon>
    </span>
  );
}
